import { render, staticRenderFns } from "./SendBriefButlerModal.vue?vue&type=template&id=2a517020&scoped=true"
import script from "./SendBriefButlerModal.vue?vue&type=script&lang=js"
export * from "./SendBriefButlerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a517020",
  null
  
)

export default component.exports